<nida-web-site-wrapper headline="Current patients">
  <nida-web-card [disableHeadline]="true">
    <nida-web-patient-table-current></nida-web-patient-table-current>
  </nida-web-card>
</nida-web-site-wrapper>
